import React from "react";

import { getDefaultCountryOptionDrop, getTranslateByKey } from "@/main/services/utils";

import Box from "@/main/components/shared/box";
import VehicleFilterFields from "@/main/components/shared/vehicleFilterFields/vehicleFilterFields";
import { userIsAdmin } from "@/main/services/utilsUser";
import { useCountryReducer } from "@/main/store/country";

import { usePreQuoteContext } from "../context";
import * as S from "./styles";
import { Controls } from "@/main/services/constants/constantsControl";
import useKogControlElementId from "@/main/hooks/useKogControlElementId";

interface ISectionVehicleProps {
	setOpenModalImages: React.Dispatch<React.SetStateAction<boolean>>;
}

function SectionVehicle(_: ISectionVehicleProps) {
	const CONTROL_VEHICLE_SECTION = useKogControlElementId(Controls.IdVehicleSession);

	const { preQuoteData, setIsChangedVehicleForm } = usePreQuoteContext();
	const { countriesUser: countryReducer } = useCountryReducer();
	const isAdmin = userIsAdmin();
	const optionDefaultCountryDrop = getDefaultCountryOptionDrop(countryReducer.data);
	const guidCountryDefault = optionDefaultCountryDrop ? String(optionDefaultCountryDrop.key) : null;

	if (!preQuoteData?.vehiclePending || !CONTROL_VEHICLE_SECTION) return null;

	const guidCountryToSelect = preQuoteData.vehicleGuidCountry || guidCountryDefault;

	return (
		<>
			<Box showBox={true} title={getTranslateByKey("information.vehicleInformation")}>
				<S.RowInputsVehicleInformation>
					<VehicleFilterFields
						idPrefix="id-preQuote"
						isRequired={true}
						isRequiredCountry={false}
						isDisabledCountry={!isAdmin}
						isDisabledManufacturer={!isAdmin}
						isDisabledModel={!isAdmin}
						guidCountryToSelect={guidCountryToSelect}
						onVehicleChange={() => setIsChangedVehicleForm(true)}
					/>
				</S.RowInputsVehicleInformation>
			</Box>
		</>
	);
}

export default SectionVehicle;
